import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

const useStyles = makeStyles((theme) => ({
  groupHeader: {
    padding: theme.spacing(2),
    borderBottom: "1px solid #e0e0e0",
  },
  groupId: {
    color: "#9c27b0",
    fontWeight: "bold",
    fontSize: "1.1rem",
    marginBottom: theme.spacing(0.5),
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  groupTitle: {
    fontWeight: "bold",
    fontSize: "1rem",
    marginBottom: theme.spacing(1),
  },
  productCountBadge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    backgroundColor: "#4caf50",
    color: "#fff",
    fontSize: "0.75rem",
    fontWeight: "bold",
    marginRight: theme.spacing(1),
  },
}));

export default function GroupHeader({ groupId, groupTitle, productCount }) {
  const classes = useStyles();

  const handleGroupIdClick = () => {
    window.open(`/matching-group/${groupId}`, '_blank');
  };

  return (
    <div className={classes.groupHeader}>
      <Typography 
        className={classes.groupId}
        onClick={handleGroupIdClick}
      >
        #{groupId}
      </Typography>
      <Typography className={classes.groupTitle}>
        {groupTitle}
      </Typography>
      {productCount !== null && productCount !== undefined && (
        <Box display="flex" alignItems="center">
          <span className={classes.productCountBadge}>
            {productCount}
          </span>
          <Typography variant="body2">
            Products in group
          </Typography>
        </Box>
      )}
    </div>
  );
}
